import { DateHelper } from "../../../../Common/DateHelper";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export class TicketedEvent extends ODataSelect
{
    public Node_Id = 0;
    public Ticketed_Event_Id = "";
    public Booking_Id = "";
    public Event_Title = "";
    public Event_Short_Description = "";
    public Event_Description = "";
    public WebSite_URL = "";
    public ImageURI = "";
    public Event_Date = DateHelper.null();
    public Event_Start_DateTime = DateHelper.null();
    public Event_End_DateTime = DateHelper.null();
    public Event_Capacity = 0;
    public IsWaitingList_Allowed = 0;
    public Invite_Permission = "";
    public Event_Status = "";
    public Event_Owner = "";
    public Phone = "";
    public IsManageBy_3rdParty = 0;
    public IsCost_Associated = 0;
    public Ticket_Price = 0;
    public IsBroadcast_ToIBSS = 0;
    public IsAttendees_CheckingIn = 0; 
    public IsDraft = 0;
    public IsCatering_Available = 0;

    public init(response: any, nodeId: number): TicketedEvent
    {
        super.init(response, nodeId);
        this.Event_Date = DateHelper.fromIsoByNode(response.Event_Date, nodeId);
        this.Event_Start_DateTime = DateHelper.fromIsoByNode(response.Event_Start_DateTime, nodeId);
        this.Event_End_DateTime = DateHelper.fromIsoByNode(response.Event_End_DateTime, nodeId);
        return this;
    }
}

export class BookingParty extends ODataSelect
{
    public Booking_Participant_Email = "";
    public Booking_Participant_Name = "";
    public Booking_Participant_Organisation = "";
    public Booking_Participant_Type = 0;
    public IsParticipant_On_WaitingList = 0;
    public DisableExtUpdate = true;
    public Record_Id = "";

    public init(response: any, nodeId: number): BookingParty
    {
        super.init(response, nodeId);
        return this;
    }
}

export interface ISpaceData
{
    Node_Id: number;
    Space_Id: string;
    Space_Type: string;
}

export class Bookings extends ODataSelect
{
   
    public Booking_Start = DateHelper.null();
    public Booking_End = DateHelper.null();
    public Space_Id = '';

    public init(response: any, nodeId: number): Bookings
    {
        super.init(response, nodeId);
        this.Booking_Start = DateHelper.fromIsoByNode(response.Booking_Start, nodeId);
        this.Booking_End = DateHelper.fromIsoByNode(response.Booking_End, nodeId);
        this.Space_Id = response.Space_Id;
        return this;
    }
}
